import { h, render, Component } from 'preact';
import { classNames} from '../utils/utils';

class TxrCheckbox extends Component {
    state = {
    }
    path = 'isChecked';
    componentDidMount() {
        if(this.props.isCheckedField) {
            this.path = this.props.isCheckedField;
        }
     }
    toggleChecked = (e) => {
        this.props.item[this.path] = !this.props.item[this.path];
        if(this.props.item.change) {
            this.props.item.change(this.props.item);
        }
        if(this.props.select) {
            this.props.select();
        }
        this.forceUpdate();
    }
 

    render() {
        return (
            <div class="txr-checkbox">
                <div class={'txr-checkbox__container' + (this.props.item[this.path] ? ' checked' : '')} onClick={(e) => this.toggleChecked(e)}>
                    <i class={'txr-checkbox__icon' + (this.props.item[this.path] ? ' fas fa-check-square' : ' fal fa-square')}></i>
                    <span class="txr-checkbox__text">{this.props.label}</span>
                </div>
            </div>
        )
    }
}
export default TxrCheckbox;